export default __webpack_public_path__ + "static/media/transfer_action.4e5e17ad.svg";